import { render, staticRenderFns } from "./fraudcases.vue?vue&type=template&id=79a1d3e0"
import script from "./fraudcases.vue?vue&type=script&lang=js"
export * from "./fraudcases.vue?vue&type=script&lang=js"
import style0 from "./fraudcases.vue?vue&type=style&index=0&id=79a1d3e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports